import React, {useState, useEffect} from "react";
import {useNavigate}              from "react-router-dom";
import {ListGroup}                from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import Button                     from '@material-ui/core/Button'
import Grid                       from '@material-ui/core/Grid'
import ImageList                   from '@material-ui/core/ImageList'; //2021.11.20 Material-UIのツール名称変更（GridList→ImageList）に伴い変更
import FamikarHeader              from '../components/FamikarHeader';
import MemberData                 from '../components/MemberData';
import firebase from'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

/**
 * FamilyHome: 家族ホーム画面コンポーネント
 *
 * 役割:
 * - 家族に属するメンバー一覧を表示
 * - 家族追加・家族招待の導線を提供
 * - ログイン状態とURLの家族IDの整合を取る
 *
 * 主な状態:
 * - `uid`, `FamilyID`, `familyids`: 表示・遷移に必要な識別情報
 * - `memberList`: メンバー一覧（表示名・誕生日・画像URLなど）
 *
 * 画面遷移:
 * - 未ログイン時 `/Login` へ遷移
 * - `FamilyID` 未指定時は `Person/{uid}` の先頭FamilyIDで `/FamilyHome/:FamilyID` に置換
 */
const InvitationButtonDisplay = 'block' //家族を招待しましょうのボタンを表示する
const envLabel = process.env.REACT_APP_ENV_LABEL || ''

// const useStyles = makeStyles((theme) => ({
makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  card: {
    display: 'flex',
    maxHeight: 450,
    padding: 0,
    margin: 0
  },
}));


export default function FamilyHome(props) {
  const navigate = useNavigate()
  const [ uid,        setUid        ] = useState('')           //ログインユーザーのuid ※uidの読み込みは一旦廃止 2021.03.06 takahashi
  const [ FamilyID,   setFamilyID   ] = useState('')           
  const [ familyids,  setFamilyids  ] = useState([])           
  const [ memberList, setMemberList ] = useState([{            
    MemberID:    '',
    FamilyID:    '',
    DisplayName: '',
    BirtyDate:   null,
    BirthYear:   '',
    BirthMonth:  '',
    BirthDay:    '',
    image_url:   ''
  }])
  
    // ログイン情報取得（初回のみ）
    /**
     * ログイン情報取得:
     * - 認証ユーザを監視し、未ログインなら `/Login` に遷移
     * - `FamilyID` が未指定なら `Person/{uid}` から先頭FamilyIDを取得しURLを置換
     * - 家族名を取得してタイトル設定、メンバー一覧を読み込み
     * @param {firebase.firestore.Firestore} db Firestoreインスタンス
     * @returns {void}
     */
  const getLoginInfo = (db) => {
    // 現在ログインしているユーザを取得する。
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      try {
        if (!user) {
          navigate('/Login') //ログインしていない場合、ログイン画面へ移動
          return
        }
        const currentUid = user.uid
        setUid(currentUid)

        let resolvedFamilyId = FamilyID
        // URLに家族IDが含まれない場合、ログインユーザーの1件目の家族IDを取得する
        if (!resolvedFamilyId) {
          const personSnap = await db.collection('Person').doc(currentUid).get()
          if (!personSnap.exists) { // ユーザー情報が存在しない場合
            console.log('FamilyHome: person-not-found for uid', currentUid)
            navigate('/Invalid') //無効なURLへ移動
            return
          }
          const pdata = personSnap.data()
          const firstFamily = pdata && Array.isArray(pdata.FamilyID) ? pdata.FamilyID[0] : undefined
          if (!firstFamily || !firstFamily.id) { // 家族IDが存在しない場合
            console.log('FamilyHome: familyid-missing for uid', currentUid)
            navigate('/Invalid') //無効なURLへ移動
            return
          }
          resolvedFamilyId = firstFamily.id
          // URLを家族ID付きに置き換える
          navigate('/FamilyHome/' + resolvedFamilyId, { replace: true }) // URLを家族ID付きに置き換える
        }

        setFamilyID(resolvedFamilyId)
        setFamilyids([resolvedFamilyId])

        const famDoc = await db.collection('Family').doc(resolvedFamilyId).get()
        const familyName = famDoc.exists ? famDoc.data().FamilyName : '○○'
        document.title = `${familyName ? familyName : '○○'}家のホーム - ふぁみかるくん${envLabel}`

        const members = await getMemberList(db, resolvedFamilyId)
        setMemberList(members)
      } catch (e) {
        console.log('FamilyHome getLoginInfo error:', (e && (e.code || e.message)) || e)
        navigate('/Invalid')
      } finally {
        unsubscribe() // リスナー解除
      }
    })
  }

  // 家族情報取得
  /**
   * 家族メンバー一覧取得:
   * - `Family/{familyId}/Member` を表示名で並び替えて取得
   * - `DeleteFlag` が false のみ採用し、誕生日を日付型へ変換
   * - 誕生日の新しい順、同値時は表示名で安定ソート
   * @param {firebase.firestore.Firestore} db Firestoreインスタンス
   * @param {string} familyId 家族ID
   * @returns {Promise<Array<Object>>} メンバー一覧
   */
  const getMemberList = async (db, familyId) => {
    try {
      const snap = await db.collection('Family').doc(familyId).collection('Member').orderBy('DisplayName').get()
      const list = []
      snap.forEach((doc) => {
        const dataT = doc.data()
        const DeleteFlag = (dataT.DeleteFlag == null) ? false : dataT.DeleteFlag //家族情報の削除フラグがある場合は、非表示にする。(2020.08.29追加)
        if (DeleteFlag === false) {
          const _birthDate = (dataT.BirthDay == null) ? null : dataT.BirthDay.toDate()
          list.push({
            FamilyID:    familyId,          //家族ID
            MemberID:    doc.id,            //メンバーID
            DisplayName: dataT.DisplayName, //メンバー表示名
            BirthDate:   _birthDate,        //誕生日
            BirthYear:   (_birthDate === null) ? '' : _birthDate.getFullYear(),  //年
            BirthMonth:  (_birthDate === null) ? '' : _birthDate.getMonth() + 1, //月
            BirthDay:    (_birthDate === null) ? '' : _birthDate.getDate(),      //日
            image_url:   dataT.image_url,   //画像URL
          })
        }
      })

      // 若い（新しい）誕生日ほど先頭。名前の比較は数値返却に統一
      list.sort((a, b) => {
        if (a.BirthDate != null && b.BirthDate != null) { // 両方誕生日有り
          if (a.BirthDate < b.BirthDate) return 1
          if (a.BirthDate > b.BirthDate) return -1
          return String(a.DisplayName || '').localeCompare(String(b.DisplayName || '')) // 同じ場合は名前でソート
        } else if (a.BirthDate == null && b.BirthDate == null) { // 両方誕生日無し
          return String(a.DisplayName || '').localeCompare(String(b.DisplayName || '')) // 名前でソート
        } else if (a.BirthDate != null) {
          return -1
        } else if (b.BirthDate != null) {
          return 1
        }
        return 1
      })
      return list
    } catch (error) {
      console.log('Error getting family member documents:', error)
      return []
    }
  }

  // 新規登録ボタン
  /**
   * 家族新規登録導線:
   * - 家族登録画面 `/familyregist` へ state 付きで遷移
   * @returns {void}
   */
  const handlerCreateButtonClick = () =>{
    console.log("handlerCreateButtonClick famiryid:" + familyids[0])
    navigate('/familyregist', { state: {uid: uid, familyID: FamilyID, isEdit: false}})
  }

  // 家族招待ボタン
  /**
   * 家族招待導線:
   * - 招待画面 `/Invitation/:FamilyID` へ遷移
   * @returns {void}
   */
  const handlerInvitationButtonClick = () =>{
    console.log("handlerInvitationButtonClick famiryid:" + familyids[0])
    navigate('/Invitation/' + FamilyID)
  }

  /**
   * 初回マウント時処理:
   * - Firestore を初期化し、ログイン情報取得を実行
   */
  useEffect(() => { // 初回のみ
    const db = firebase.firestore();
    getLoginInfo(db) // ログイン情報取得
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * アンマウント時処理:
   * - ページタイトルを初期値に戻す
   */
  useEffect(() => { //ページを離れる際に実行
    // componentDidMount のタイミングで実行したい処理を記述
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, []);

  return (
    <React.Fragment>
      <div>
        {uid !== '' ? <FamikarHeader uid={uid} FamilyID={FamilyID} isHome={true} /> : null}
        <Grid container spacing={0}>
          {/* ~ 家族ホーム画面の「家族ホーム」表記削除＋「新規追加」ボタンの削除 ~
          <Grid container justify="flex-start">
            <Grid item xs={8}>
              <Typography variant="h6" align='left'>
                家族ホーム
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Button variant="outlined" color="primary" onClick={this.handlerCreateButtonClick}>新規追加</Button>
            </Grid>
          </Grid>
          */}
          {/* メンバー一覧 */}
          <Grid container justifyContent="space-between" alignItems="stretch">
            <Grid item xs={12}>
              <ImageList cols={1}>
                {/* {console.log("typeof:"+typeof memberList)} */}
                {/* {console.log(memberList.length)} */}
                {/* <MemberData memberName={memberName} member_url={url} memberID={member.MemberID} familyID={member.FamilyID} uid={uid} /> */}
                {memberList.map((member)=>(
                  member.MemberID !== '' 
                  ? <ListGroup.Item as="li" className="justify-md-left align-left" key={member.MemberID} style={{height:86}}>
                      <MemberData memberName={member.DisplayName} member_url={member.image_url} memberID={member.MemberID} familyID={member.FamilyID} uid={uid} />
                    </ListGroup.Item>
                  : null
                  ))
                }
                {/* <MemberData memberName="test" /> */}
              </ImageList>
            </Grid>
            {/* {console.log("FamilyHome.js return memberList.length[" + memberList.length + "]")} */}
          </Grid>
          {/* 新規追加ボタンは画面下部に移動 */}
          <Grid container spacing={0} style={{marginTop: "16px"}}>
            <Grid item xs={12}>
              <Button variant="contained" style={{width: "calc(100% - 16px)", margin: "0 auto", padding: "16px 0px", backgroundColor: '#faf0e6'}} onClick={()=>handlerCreateButtonClick()}>
                ＋&nbsp;家族を追加しましょう
              </Button>
            </Grid>
          </Grid>
          {/* 家族招待画面へのリンクを表示する（開発者のみ） */}
          <Grid container spacing={0} style={{marginTop: "16px"}}>
            <Grid item xs={12}>
              <Button variant="contained" style={{width: "calc(100% - 16px)", margin: "0 auto", padding: "16px 0px", backgroundColor: '#d6ffd6', display: InvitationButtonDisplay}} onClick={()=>handlerInvitationButtonClick()}>
                ＋&nbsp;家族を招待しましょう
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  )
}
